import type { OktaAuthOptions } from '@okta/okta-auth-js/core';

export const CALLBACK_PATH = '/login/callback';

export interface AuthSettings {
  issuer: string;
  clientId: string;
}

interface AuthEnv {
  VITE_API_BASE_URL?: string | undefined;
  VITE_OKTA_ISSUER?: string | undefined;
  VITE_OKTA_CLIENT_ID?: string | undefined;
}

/**
 * The console signs in only when both Okta variables are set and it talks to a real API
 * (CHG-050). The mock, and a build without the variables, keep the typed name and no sign-in.
 */
export function authSettings(env: AuthEnv): AuthSettings | null {
  const issuer = env.VITE_OKTA_ISSUER?.trim();
  const clientId = env.VITE_OKTA_CLIENT_ID?.trim();
  if (!issuer || !clientId || !env.VITE_API_BASE_URL?.trim()) return null;
  return { issuer, clientId };
}

/** Authorization code with PKCE; tokens live in sessionStorage (one tab, gone when it closes). */
export function oktaOptions(settings: AuthSettings, origin: string): OktaAuthOptions {
  return {
    issuer: settings.issuer,
    clientId: settings.clientId,
    redirectUri: `${origin}${CALLBACK_PATH}`,
    scopes: ['openid', 'profile', 'email', 'offline_access'],
    pkce: true,
    tokenManager: { storage: 'sessionStorage', autoRenew: true },
  };
}
